export default __webpack_public_path__ + "static/media/pinterest.b113a35e.svg";